import { j as _slicedToArray, e as _defineProperty, _ as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-047e4aae.js';
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled, { withTheme } from 'styled-components';
import { W as WithTooltip } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import color from '@styled-system/color';
import border from '@styled-system/border';
import { variant } from '@styled-system/variant';
import typography from '@styled-system/typography';
import { T as Text } from './text-5e5c8ea1.js';
import layout from '@styled-system/layout';
import flexbox from '@styled-system/flexbox';
import position from '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';
import './IconWrapper-f69d60c7-8a74d4d9.js';
import grid from '@styled-system/grid';
import background from '@styled-system/background';
import './index.esm-f8e9e79f-5619e21b.js';
import { A as ArrowDownIcon } from './ArrowDownIcon-163348d2.js';

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var width = layout.width,
    height = layout.height,
    minWidth = layout.minWidth,
    minHeight = layout.minHeight,
    maxWidth = layout.maxWidth,
    maxHeight = layout.maxHeight,
    size = layout.size,
    verticalAlign = layout.verticalAlign,
    display = layout.display,
    overflow = layout.overflow,
    overflowX = layout.overflowX,
    overflowY = layout.overflowY;
var opacity = color.opacity;
var fontSize = typography.fontSize,
    fontFamily = typography.fontFamily,
    fontWeight = typography.fontWeight,
    lineHeight = typography.lineHeight,
    textAlign = typography.textAlign,
    fontStyle = typography.fontStyle,
    letterSpacing = typography.letterSpacing;
var alignItems = flexbox.alignItems,
    alignContent = flexbox.alignContent,
    justifyItems = flexbox.justifyItems,
    justifyContent = flexbox.justifyContent,
    flexWrap = flexbox.flexWrap,
    flexDirection = flexbox.flexDirection,
    flex = flexbox.flex,
    flexGrow = flexbox.flexGrow,
    flexShrink = flexbox.flexShrink,
    flexBasis = flexbox.flexBasis,
    justifySelf = flexbox.justifySelf,
    alignSelf = flexbox.alignSelf,
    order = flexbox.order;
var gridGap = grid.gridGap,
    gridColumnGap = grid.gridColumnGap,
    gridRowGap = grid.gridRowGap,
    gridColumn = grid.gridColumn,
    gridRow = grid.gridRow,
    gridAutoFlow = grid.gridAutoFlow,
    gridAutoColumns = grid.gridAutoColumns,
    gridAutoRows = grid.gridAutoRows,
    gridTemplateColumns = grid.gridTemplateColumns,
    gridTemplateRows = grid.gridTemplateRows,
    gridTemplateAreas = grid.gridTemplateAreas,
    gridArea = grid.gridArea;
var borderWidth = border.borderWidth,
    borderStyle = border.borderStyle,
    borderColor = border.borderColor,
    borderTop = border.borderTop,
    borderRight = border.borderRight,
    borderBottom = border.borderBottom,
    borderLeft = border.borderLeft,
    borderRadius = border.borderRadius;
var backgroundImage = background.backgroundImage,
    backgroundSize = background.backgroundSize,
    backgroundPosition = background.backgroundPosition,
    backgroundRepeat = background.backgroundRepeat;
var zIndex = position.zIndex,
    top = position.top,
    right = position.right,
    bottom = position.bottom,
    left = position.left;

/**
 * Color mapping for the Option's text and icon for respective states.
 */
var OPTION_CONTENT_COLOR_MAPPING = function OPTION_CONTENT_COLOR_MAPPING(colors) {
  return {
    active: colors.blue.haptik,
    hover: colors.grey.deep,
    "default": colors.grey.deep
  };
};

/**
 * Color mapping for the Option's background for respective states.
 */
var OPTION_BACKGROUND_COLOR_MAPPING = function OPTION_BACKGROUND_COLOR_MAPPING(colors) {
  return {
    active: colors.blue.pastel,
    hover: colors.grey.neon,
    "default": colors.background
  };
};

/**
 * Color mapping for the New Icons set
 */
var ICON_COLOR_MAPPING = {
  active: "blue.haptik",
  hover: "grey.deep",
  "default": "grey.deep"
};

var Container = styled(Box)({
  alignItems: "center",
  cursor: "pointer",
  transition: ".3s ease-out",
  height: "40px",
  overflow: "hidden",
  boxSizing: "border-box",
  userSelect: "none",
  padding: function padding(props) {
    return "0 ".concat(props.theme.space.sm, "px");
  },
  borderRadius: function borderRadius(props) {
    return "".concat(props.theme.radii.sm, "px");
  },
  marginBottom: function marginBottom(props) {
    return "".concat(props.theme.space.sm, "px");
  },
  background: function background(props) {
    return props.color;
  },
  svg: {
    minWidth: "24px",
    minHeight: "24px"
  },
  div: {
    div: {
      marginRight: 4,
      svg: {
        minWidth: "14px",
        minHeight: "14px",
        transform: function transform(props) {
          return props.isExpanded ? "rotate(0deg)" : "rotate(-90deg)";
        }
      }
    }
  }
});
var SubOptionWrapper = styled(Box)({
  cursor: "pointer",
  borderRadius: function borderRadius(props) {
    return "".concat(props.theme.radii.sm, "px");
  },
  marginBottom: function marginBottom(props) {
    return "".concat(props.theme.space.sm, "px");
  },
  alignItems: "center",
  "&:hover": {
    backgroundColor: function backgroundColor(props) {
      return props.theme.colors.grey.neon;
    },
    fontWeight: function fontWeight(props) {
      return props.theme.fontWeights.semiBold;
    },
    color: function color(props) {
      return props.theme.colors.blue.haptik;
    }
  },
  backgroundColor: function backgroundColor(props) {
    return props.selected ? "#f6f6f6" : null;
  }
});
var OptionText = styled(Text)({
  padding: 0,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  color: function color(props) {
    return props.color;
  },
  transition: "0.3s opacity ease-in",
  marginLeft: function marginLeft(props) {
    return "".concat(props.theme.space.sm, "px");
  }
});
var OptionExtras = styled("div")({
  transition: "0.3s opacity ease-in"
});
var Divider = styled("div")({
  height: "1px",
  marginTop: "14px",
  marginBottom: "18px",
  backgroundColor: function backgroundColor(props) {
    return props.theme.colors.grey.haptik;
  }
});
var Option = function Option(_ref) {
  var children = _ref.children,
    isActive = _ref.isActive,
    icon = _ref.icon,
    _ref$extras = _ref.extras,
    extras = _ref$extras === void 0 ? null : _ref$extras,
    onClick = _ref.onClick,
    theme = _ref.theme,
    subOptions = _ref.subOptions,
    isExpanded = _ref.isExpanded,
    selectedSubIndex = _ref.selectedSubIndex,
    setSelectedSubIndex = _ref.setSelectedSubIndex,
    isSelectedOption = _ref.isSelectedOption;
  var Icon = icon;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isHovering = _React$useState2[0],
    setIsHovering = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOptionExpanded = _React$useState4[0],
    setIsOptionExpanded = _React$useState4[1];

  /**
   * Option have 3 states : hover, active and default.
   * This method returns the current state of option.
   */
  var optionState = useMemo(function () {
    if (isActive) return "active";
    if (isHovering) return "hover";
    return "default";
  }, [isActive, isHovering]);
  var onSubOptionSelected = function onSubOptionSelected(key) {
    setSelectedSubIndex(key);
  };
  var onOptionSelected = function onOptionSelected() {
    onClick();
    if (isSelectedOption && isOptionExpanded) {
      setIsOptionExpanded(false);
    } else if (subOptions.length) {
      setIsOptionExpanded(true);
    } else {
      setIsOptionExpanded(false);
    }
  };
  var optionBackgroundColor = OPTION_BACKGROUND_COLOR_MAPPING(theme.colors)[optionState];
  var optionContentColor = OPTION_CONTENT_COLOR_MAPPING(theme.colors)[optionState];
  var iconColor = ICON_COLOR_MAPPING[optionState];
  var SubOption = function SubOption() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, subOptions.map(function (subOption, key) {
      var SubIcon = subOption.icon;
      var isSelected = isActive && selectedSubIndex === key;
      return /*#__PURE__*/React.createElement(SubOptionWrapper, {
        selected: isSelected,
        onClick: function onClick() {
          return onSubOptionSelected(key);
        }
      }, subOption.icon && /*#__PURE__*/React.createElement(Box, {
        width: 24,
        height: 24,
        padding: 0
      }, /*#__PURE__*/React.createElement(SubIcon, {
        iconColor: "grey.deep",
        size: "small"
      })), isExpanded && /*#__PURE__*/React.createElement(OptionText, {
        variant: isSelected ? "h4.semi-bold" : "body.md"
      }, subOption.text));
    }), /*#__PURE__*/React.createElement(Divider, null));
  };
  return /*#__PURE__*/React.createElement(Box, {
    display: "block",
    padding: 0
  }, /*#__PURE__*/React.createElement(Container, {
    onMouseEnter: function onMouseEnter() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    },
    color: optionBackgroundColor,
    onClick: onOptionSelected,
    "data-testid": "sidebar-option",
    isExpanded: isOptionExpanded && isSelectedOption
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    color: optionContentColor,
    iconColor: iconColor
  }), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    padding: "zero",
    alignItems: "center",
    justifyContent: "space-between",
    flex: "1",
    maxWidth: "132px"
  }, /*#__PURE__*/React.createElement(OptionText, {
    color: optionContentColor,
    variant: "h4.semi-bold"
  }, children), /*#__PURE__*/React.createElement(OptionExtras, null, extras), subOptions && subOptions.length ? /*#__PURE__*/React.createElement(ArrowDownIcon, {
    size: "extraSmall",
    color: optionContentColor,
    iconColor: iconColor
  }) : null)), subOptions.length > 0 && isOptionExpanded && isSelectedOption && /*#__PURE__*/React.createElement(SubOption, null));
};
Option.propTypes = {
  children: PropTypes.node,
  isActive: PropTypes.bool,
  icon: PropTypes.elementType,
  extras: PropTypes.node,
  onClick: PropTypes.func,
  subOptions: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.elementType,
    text: PropTypes.string
  })),
  isExpanded: PropTypes.bool,
  selectedSubIndex: PropTypes.number,
  setSelectedSubIndex: PropTypes.func,
  isSelectedOption: PropTypes.bool // this is applicable only suboptions are available
};
Option.defaultProps = {
  children: null,
  icon: null,
  isActive: false,
  extras: null,
  onClick: null,
  subOptions: [],
  isExpanded: false,
  selectedSubIndex: null,
  setSelectedSubIndex: function setSelectedSubIndex() {},
  isSelectedOption: false
};
Option.Text = OptionText;
Option.Extras = OptionExtras;
Option.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Option",
  "props": {
    "extras": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "icon": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "elementType"
      },
      "required": false,
      "description": ""
    },
    "isActive": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "subOptions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "icon": {
              "name": "elementType",
              "required": false
            },
            "text": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": ""
    },
    "isExpanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "selectedSubIndex": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "setSelectedSubIndex": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "isSelectedOption": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
var Option$1 = withTheme(Option);

function SidebarFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    padding: "zero",
    marginBottom: "md",
    overflow: "hidden"
  }, children);
}
SidebarFooter.propTypes = {
  children: PropTypes.node
};
SidebarFooter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SidebarFooter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

var ExpandButtonIcon = function ExpandButtonIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.5L6.75 9L11.25 13.5",
    stroke: "#858585",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
ExpandButtonIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ExpandButtonIcon"
};

var _templateObject;
var collapsedContainerWidth = "64px";
var Wrapper = styled(Box)({
  padding: 0,
  display: "block",
  height: "100%"
}, variant({
  prop: "mode",
  variants: {
    collapsed: {
      width: collapsedContainerWidth
    },
    expanded: {
      width: function width(props) {
        return "".concat(props.width, "px");
      }
    }
  }
}));
var Container$1 = styled("aside")({
  height: "100%",
  position: "relative",
  backgroundColor: "white",
  transition: "0.3s width cubic-bezier(0.22, 1, 0.36, 1)",
  flexDirection: "column",
  padding: "20px 11px",
  boxSizing: "border-box",
  display: "flex",
  width: function width(props) {
    return "".concat(props.width, "px");
  },
  zIndex: 100,
  boxShadow: function boxShadow(props) {
    return props.mode === "expanded" ? "0px 0px 4px 0px rgba(0, 0, 0, 0.2)" : "none";
  }
}, variant({
  prop: "mode",
  variants: {
    collapsed: _defineProperty(_defineProperty({
      width: collapsedContainerWidth
    }, Option$1.Text, {
      opacity: 0
    }), Option$1.Extras, {
      opacity: 0
    }),
    expanded: _defineProperty(_defineProperty({}, Option$1.Text, {
      opacity: 1
    }), Option$1.Extras, {
      opacity: 1
    })
  }
}), variant({
  prop: "position",
  variants: {
    right: {
      "border-left": "1px solid #D5D5D5",
      "margin-left": "auto"
    },
    left: {
      "border-right": "1px solid #D5D5D5"
    }
  }
}));
var Divider$1 = styled("div")({
  height: "1px",
  marginTop: "14px",
  marginBottom: "18px",
  backgroundColor: function backgroundColor(props) {
    return props.theme.colors.grey.haptik;
  }
});
var ExpandButtonContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  background-color: ", ";\n  border: ", ";\n  box-sizing: border-box;\n  border-radius: 60px;\n  right: -15px;\n  cursor: pointer;\n  z-index: 100;\n  bottom: 20px;\n  transition: 0.3s ease-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: ", ";\n  \"&:hover\": {\n    backgroundcolor: ", ";\n  }\n  > span {\n    // span generated inside withtooltip wrapper\n    display: flex;\n    align-items: center;\n  }\n  ", ",\n"])), function (props) {
  return props.theme.colors.grey.pastel;
}, function (props) {
  return "1px solid ".concat(props.theme.colors.grey.haptik);
}, function (props) {
  return props.isExpanded ? "rotate(0deg)" : "rotate(-180deg)";
}, function (props) {
  return props.theme.colors.grey.soft;
}, function (props) {
  return props.position === "right" && "\n    transform: ".concat(props.isExpanded ? "rotate(-180deg)" : "rotate(-0deg)", ";\n    left: -15px;\n  ");
});
var OptionWrapper = styled("div")({
  flex: "1",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "6px"
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent"
  },
  "&::-webkit-scrollbar-thumb": {
    // TO DO - Check this color with Designer Team
    background: "#d9d9d9",
    borderRadius: "10px"
  },
  "&::-webkit-scrollbar-thumb:hover": {
    // TO DO - Check this color with Designer Team
    background: "#b0b0b0"
  }
});
function ExpandbuttonWrapper(_ref) {
  var showTooltip = _ref.showTooltip,
    isExpanded = _ref.isExpanded;
  return showTooltip ? /*#__PURE__*/React.createElement(WithTooltip, {
    tooltip: isExpanded ? "Collapse Panel" : "Show Panel"
  }, /*#__PURE__*/React.createElement(ExpandButtonIcon, null)) : /*#__PURE__*/React.createElement(ExpandButtonIcon, null);
}
ExpandbuttonWrapper.propTypes = {
  showTooltip: PropTypes.bool,
  isExpanded: PropTypes.bool
};
function SidebarV2(_ref2) {
  var children = _ref2.children,
    _ref2$expanded = _ref2.expanded,
    expanded = _ref2$expanded === void 0 ? false : _ref2$expanded,
    _ref2$visible = _ref2.visible,
    visible = _ref2$visible === void 0 ? true : _ref2$visible,
    _ref2$footer = _ref2.footer,
    footer = _ref2$footer === void 0 ? null : _ref2$footer,
    _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? "left" : _ref2$position,
    _ref2$showContentOnCo = _ref2.showContentOnCollapse,
    showContentOnCollapse = _ref2$showContentOnCo === void 0 ? true : _ref2$showContentOnCo,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? "200" : _ref2$width,
    _ref2$showExpandBtnTo = _ref2.showExpandBtnTooltip,
    showExpandBtnTooltip = _ref2$showExpandBtnTo === void 0 ? false : _ref2$showExpandBtnTo,
    _ref2$hoverEffect = _ref2.hoverEffect,
    hoverEffect = _ref2$hoverEffect === void 0 ? false : _ref2$hoverEffect;
  var _useState = useState(expanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(isExpanded ? "expanded" : "collapsed"),
    _useState4 = _slicedToArray(_useState3, 2),
    wrapperMode = _useState4[0],
    setWrapperMode = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hovered = _useState6[0],
    setHovered = _useState6[1];
  var expandButtonRef = React.useRef(null);
  if (!visible) return null;
  var onHover = function onHover(e) {
    if (hoverEffect && !isExpanded) {
      var ignoreHover = e.target === expandButtonRef.current || e.target.parentElement === expandButtonRef.current || e.target.parentElement.parentElement === expandButtonRef.current;
      if (!ignoreHover) {
        setWrapperMode("collapsed");
        setHovered(true);
        setIsExpanded(true);
      }
    }
  };
  var hideHoverEffect = function hideHoverEffect() {
    if (hovered) {
      setWrapperMode("collapsed");
      setHovered(false);
      setIsExpanded(false);
    }
  };
  var toggleExpandState = function toggleExpandState() {
    if (hoverEffect) setWrapperMode(isExpanded ? "collapsed" : "expanded");
    setIsExpanded(!isExpanded);
  };
  var renderedChildren = React.Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        isExpanded: isExpanded
      });
    }
    return child;
  });
  return /*#__PURE__*/React.createElement(Wrapper, {
    mode: wrapperMode,
    width: width
  }, /*#__PURE__*/React.createElement(Container$1, {
    mode: isExpanded || hovered ? "expanded" : "collapsed",
    position: position,
    width: width,
    onMouseOver: function onMouseOver(e) {
      return onHover(e);
    },
    onMouseLeave: hideHoverEffect
  }, (isExpanded || showContentOnCollapse || hovered) && /*#__PURE__*/React.createElement(OptionWrapper, null, renderedChildren), footer && /*#__PURE__*/React.createElement(SidebarFooter, null, footer(isExpanded)), /*#__PURE__*/React.createElement(ExpandButtonContainer, {
    isExpanded: isExpanded,
    onClick: toggleExpandState,
    "data-testid": "sidebar-expand-button",
    position: position,
    ref: expandButtonRef
  }, /*#__PURE__*/React.createElement(ExpandbuttonWrapper, {
    showTooltip: showExpandBtnTooltip,
    isExpanded: isExpanded
  }))));
}
SidebarV2.propTypes = {
  children: PropTypes.node,
  expanded: PropTypes.bool,
  visible: PropTypes.bool,
  footer: PropTypes.node,
  position: PropTypes.string,
  showContentOnCollapse: PropTypes.bool,
  width: PropTypes.string,
  showExpandBtnTooltip: PropTypes.bool,
  hoverEffect: PropTypes.bool
};
SidebarV2.Option = Option$1;
SidebarV2.Divider = Divider$1;
SidebarV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SidebarV2",
  "props": {
    "expanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "visible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "footer": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "position": {
      "defaultValue": {
        "value": "\"left\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "showContentOnCollapse": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "defaultValue": {
        "value": "\"200\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "showExpandBtnTooltip": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "hoverEffect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

export default SidebarV2;
